import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { AxiosError } from "axios";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

const editAnnouncement = async (args: {
	id: number;
	payload: FormData;
}): Promise<void> => {
	await cmsClient.patch(`/announcements/${args.id}/`, args.payload, {
		headers: { "Content-Type": "multipart/form-data" }
	});
};

const useEditAnnouncement = () => {
	const queryClient = useQueryClient();

	const onSuccess = (
		_data: void,
		variables: { id: number; payload: FormData }
	) => {
		toast.success(
			<CustomToast
				type="Success"
				message="Announcement updated successfully"
			/>,
			{ hideProgressBar: true }
		);
		queryClient.invalidateQueries(["announcements"]);
		queryClient.invalidateQueries(["announcement", variables.id]);
	};

	const onError = (error: unknown) => {
		const axiosError = error as AxiosError;
		const message =
			axiosError?.response?.status === 409
				? "This announcement has already been sent and cannot be edited."
				: "Something went wrong, try again";
		toast.error(<CustomToast type="Error" message={message} />, {
			hideProgressBar: true
		});
	};

	const mutation = useMutation(editAnnouncement, { onError, onSuccess });
	return mutation;
};

export default useEditAnnouncement;
